import createStore from "astrid-helpers/src/createStore";
export const [getCursor, setCursor, useCursor] = createStore(true);
//# sourceMappingURL=cursor.js.map